export default "__VITE_ASSET__C$uze6mE__"